import res from "../assets/images/resources1.png";
import '../styles/resources.css';

function Resources() {
    return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <h1 style={{ marginBottom: '30px' }}>Resources</h1>
            <div className="resources-grid">
                <a href="https://docs.google.com/document/d/12Be_4zIUcz8xkC1jnlbSwCfLch4eiJhVqtn0Syusv70/edit?usp=sharing" className="textposition resource-link">
                    <img src={res} alt="Qiskit" className="resourcespic"/>
                    <h2>Install Qiskit</h2>
                    <p>Learn how to install Qiskit</p>
                </a>
                <a href="https://github.com/sandraalhames/Q-3-Qompute-2025" className="textposition resource-link">
                    <img src={res} alt="USC Qompute Challenges" className="resourcespic"/>
                    <h2>USC's Qompute 2025 Challenges</h2>
                    <p>Custom quantum computing challenges to be solved with IBM Qiskit!</p>
                </a>
                <a href="https://drive.google.com/file/d/1KckUabdQAdSdR_PB2L-K9yyYI2TJ-6Pd/view?usp=sharing" className="textposition resource-link">
                    <img src={res} alt="Qiskit 101 Practice Lab" className="resourcespic"/>
                    <h2>Qiskit 101 Practice Lab</h2>
                    <p>A Qiskit lab to help participants get started with quantum computing and prepare for Qompute 2025.</p>
                </a>

                <a href="https://drive.google.com/drive/folders/1h8H3HqeEugLJRGnizbYnJ-sTYo3oBGBV?usp=sharingn" className="textposition resource-link">
                    <img src={res} alt="USC Qompute Resources" className="resourcespic"/>
                    <h2>USC's Qompute Resources</h2>
                    <p>A custom curation of learning resources, Qiskit installation instructions, and more. This folder was built for USC Qompute participants but is accessible to all!</p>
                </a>

                <a href="https://www.youtube.com/watch?v=gbWYWeULkLA" className="textposition resource-link">
                    <img src={res} alt="Quantum Art" className="resourcespic"/>
                    <h2>The Future of Quantum & Art</h2>
                    <p>How quantum technologies will shape the future of art and media by Victoria Kumaran</p>
                </a>

                <a href="https://youtu.be/MzRCDLre1b4?si=-8wi5QRYdY3OyE-U" className="textposition resource-link">
                    <img src={res} alt="Quantum Mechanics" className="resourcespic"/>
                    <h2>Light quantum mechanics</h2>
                    <p>Great overview of quantum with amazing visuals!</p>
                </a>
                <a href="https://ocw.mit.edu/courses/18-435j-quantum-computation-fall-2003/" className="textposition resource-link">
                    <img src={res} alt="MIT OCW" className="resourcespic"/>
                    <h2>MIT OCW</h2>
                    <p>MIT quantum computation course</p>
                </a>

                <a href="https://www.youtube.com/@TheWiserOrg" className="textposition resource-link">
                    <img src={res} alt="Wiser" className="resourcespic"/>
                    <h2>WISER</h2>
                    <p>Quantum training videos from our prize sponsor</p>
                </a>

                <a href="https://drive.google.com/file/d/1ajLHmE8VeMAAtZq1k-aqqlNunWvRhNA-/view?usp=sharing" className="textposition resource-link">
                    <img src={res} alt="Notebook" className="resourcespic"/>
                    <h2>Notebook</h2>
                    <p>Download this Notebook for more practice using Qiskit, more updated Notebooks soon!</p>
                </a>

                <a href="https://www.keysight.com/us/en/learn/bootcamp/139273.html" className="textposition resource-link">
                    <img src={res} alt="Bootcamp" className="resourcespic"/>
                    <h2>Bootcamp</h2>
                    <p>Design challenges of superconducting quantum chips</p>
                </a>

                <a href="https://github.com/OJB-Quantum/QC-Hardware-How-To" className="textposition resource-link">
                    <img src={res} alt="Bootcamp" className="resourcespic"/>
                    <h2>QC Hardware How To</h2>
                    <p>Onri Jay Benally's Everything you need for quantum hardware engineering</p>
                </a>

                <a href="https://github.com/OJB-Quantum/Qiskit-Metal-to-Litho" className="textposition resource-link">
                    <img src={res} alt="Bootcamp" className="resourcespic"/>
                    <h2>Qiskit Metal to Lithography</h2>
                    <p>Onri Jay Benally's Qiskit Metal to Lithography</p>
                </a>

                <a href="https://github.com/OJB-Quantum/Free-Education" className="textposition resource-link">
                    <img src={res} alt="Bootcamp" className="resourcespic"/>
                    <h2>Free Educational Materials!!</h2>
                    <p>A collection of free educational materials, most of which are interactive or 3D animated. Curated by Onri Jay Benally</p>
                </a>

            </div>
        </div>
    );
}

export default Resources;